import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { ContractEligibleForPriceRaise } from '../model/types';

interface Params {
  page?: number;
  limit?: number;
  orderBy?: string;
  warehouseId?: string | string[];
  search?: string;
  priceRaiseDateFrom?: string;
  priceRaiseDateTo?: string;
  status?: string;
}

export const getContractsEligibleForPriceRaiseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractsEligibleForPriceRaise: builder.query<Pagination<ContractEligibleForPriceRaise>, Params>({
      query: (args) => ({
        url: '/contracts/price-raise-eligible',
        params: args,
      }),
      providesTags: ['Contracts'],
    }),
  }),
});

export const { useGetContractsEligibleForPriceRaiseQuery } = getContractsEligibleForPriceRaiseApi;
